export function getAttributes(element, attribute) {
  return element.getAttribute(attribute);
}
